import { Skeleton, SkeletonCircle, Td, Tr } from "@chakra-ui/react";
import React from "react";

interface TableSkeletonProps {
  rowCount?: number;
  columns: Array<{
    type?: "text" | "circle";
    width?: string;
    height?: string;
  }>;
}

const BaseTableSkeleton: React.FC<TableSkeletonProps> = ({
  rowCount = 10,
  columns,
}) => {
  return (
    <React.Fragment>
      {Array.from({ length: rowCount }, (_, index) => (
        <Tr key={index}>
          {columns.map((column, colIndex) => (
            <Td key={colIndex}>
              {column.type === "circle" ? (
                <SkeletonCircle
                  width={column.width || "112px"}
                  height={column.height || "36px"}
                />
              ) : (
                <Skeleton
                  width={column.width || "100%"}
                  height={column.height || "30px"}
                />
              )}
            </Td>
          ))}
        </Tr>
      ))}
    </React.Fragment>
  );
};

export default BaseTableSkeleton;